import http from "../../../services/httpService";
import { injectHtml } from "../../../utils/htmlUtil";
import { openDialog, dialogModel } from "../../common/dialog";
import { error, isEmpty, initToggleIconRotate, rotateElement } from "../../common/global";
import { catchError } from "../../../utils/errorUtil";
import { initBasketEvents } from "../../ui/basket";

const props = {
    manualFinderMarker: '#m-manual-finder',
    searchField: '#search-field',
    searchFieldButton: '#run-search',
    resultsWrapper: '#manual-finder-results-wrapper',
    resultProductWrapper: '.mf-product',
    resultProductCta: '.mf-product-cta',
    resultProductVariantWrapper: '.mf-product-variant',
    resultProductVariantCta: '.mf-product-variant-cta',
    resultProductVariantManualWrapper: '.mf-product-variant-manual',
    resultProductVariantManualSelectedLanguage: '#selected-language',
    resultProductVariantManualCta: '.mf-product-variant-manual-cta',

    //category properties
    categoriesPrimaryWrapper: '#category-level-one',
    categoriesSecondaryWrapper: '#category-level-two',
    categoriesTertiaryWrapper: '#category-level-three',

    categoriesPrimarySelect: '#PrimaryCategories',
    categoriesSecondarySelect: '#SecondaryCategories',
    categoriesTertiarySelect: '#TertiaryCategories',

    loadingAnimationWrapper: '#mf-product-loading-animation',

    //MF breadcrumbs
    //display wrappers
    breadcrumbWrapperSearchterm: '#mf-breadcrumb-searchterm-wrapper',
    breadcrumbWrapperCategoryLevelOne: '#mf-breadcrumb-category-level-one-wrapper',
    breadcrumbWrapperCategoryLevelTwo: '#mf-breadcrumb-category-level-two-wrapper',
    breadcrumbWrapperCategoryLevelThree: '#mf-breadcrumb-category-level-three-wrapper',
    breadcrumbWrapperProductSelected: '#mf-breadcrumb-product-wrapper',
    breadcrumbWrapperProductVariantSelected: '#mf-breadcrumb-product-variant-wrapper',

    //breadcrumb segments
    breadcrumbSegmentSearchterm: '#mf-breadcrumb-searchterm-segment',
    breadcrumbSegmentCategoryLevelOne: '#mf-breadcrumb-category-level-one-segment',
    breadcrumbSegmentCategoryLevelTwo: '#mf-breadcrumb-category-level-two-segment',
    breadcrumbSegmentCategoryLevelThree: '#mf-breadcrumb-category-level-three-segment',
    breadcrumbSegmentProductSelected: '#mf-breadcrumb-product-segment',
    breadcrumbSegmentProductVariantSelected: '#mf-breadcrumb-product-variant-segment'
};

export function initManualFinder() {

    if ($(props.manualFinderMarker).length) {

        initManualFinderSearch();
        initManualFinderCategories();


        clearCategoryWrapperElement(props.categoriesSecondaryWrapper);
        clearCategoryWrapperElement(props.categoriesTertiaryWrapper);

        initBreadcrumbEvents();
    }
}

async function initManualFinderSearch() {

    $(props.searchField).off("keypress").on('keypress', function (e) {
        if (e.which === 13) {
            e.preventDefault();

            runManualFinderSearch();
        }
    });

    //PURPOSE: initialises search button click event
    $(props.searchFieldButton).off("click").on('click', function (e) {
        runManualFinderSearch();
    });
    
}

async function initManualFinderCategories() {

    $(props.categoriesPrimarySelect).off("change").on('change', async function (e) {

        //first, pass selected id back to service that returns whether a sub-cat ddl shoudl be built or products returned.
        if ($(this).prop('selectedIndex') === 0) {

            //reset sub-cats, perhaps results
            clearCategoryWrapperElement(props.categoriesSecondaryWrapper);
            clearCategoryWrapperElement(props.categoriesTertiaryWrapper);

            slideUpProductResults();

            breadcrumbBuildCategoryLevelOneSelected(null, null, true);

        }
        else {

            //clear search field if any value other than the placeholder is selected.
            $(props.searchField).val('');

            const categoryId = $(this).val();
            const categoryText = $(props.categoriesPrimarySelect + ' option:selected').text();

            const data = { categoryId: categoryId };

            const result = await categorySelectedResponseService(data);

            if (result.categoryHasProducts) {

                clearCategoryWrapperElement(props.categoriesSecondaryWrapper);
                clearCategoryWrapperElement(props.categoriesTertiaryWrapper);

                //call service to load products using category id
                await getProductByCategory(categoryId);
            }
            else {

                clearCategoryWrapperElement(props.categoriesTertiaryWrapper);
                slideUpProductResults();

                //call service to load categories using category id
                await initSecondaryCategories(categoryId);
            }

            breadcrumbBuildCategoryLevelOneSelected(categoryId, categoryText, false);
        }

    });
}

async function initSecondaryCategories(categoryId) {

    const data = { categoryId: categoryId };

    const result = await getCategorySelectedContentService(data);

    await injectHtml(props.categoriesSecondaryWrapper, result);

    setTimeout(function () {

        $(props.categoriesSecondaryWrapper).fadeIn(500, function () {

            initSecondaryCategoryEvents();

        });

    }, 100);
}


async function initSecondaryCategoryEvents() {

    $(props.categoriesSecondarySelect).off("change").on('change', async function (e) {


        //first, pass selected id back to service that returns whether a sub-cat ddl shoudl be built or products returned.
        if ($(this).prop('selectedIndex') === 0) {

            //reset sub-cats, perhaps results
            clearCategoryWrapperElement(props.categoriesTertiaryWrapper);

            slideUpProductResults();

            //reset to only showing breadcrumbs up to this category. 
            breadcrumbBuildCategoryLevelTwoSelected(null, null, true);
        }
        else {

            var categoryId = $(this).val();

            const data = { categoryId: categoryId };
            const categoryText = $(props.categoriesSecondarySelect + ' option:selected').text();

            const result = await categorySelectedResponseService(data);

            if (result.categoryHasProducts) {

                clearCategoryWrapperElement(props.categoriesTertiaryWrapper);

                //call service to load products using category id
                await getProductByCategory(categoryId);
            }
            else {

                slideUpProductResults();

                //call service to load categories using category id
                await initTertiaryCategories(categoryId);
            }

            breadcrumbBuildCategoryLevelTwoSelected(categoryId, categoryText, false);
        }

    });
}


async function initTertiaryCategories(categoryId) {

    const data = { categoryId: categoryId };

    const result = await getCategorySelectedContentService(data);

    await injectHtml(props.categoriesTertiaryWrapper, result);

    setTimeout(function () {

        $(props.categoriesTertiaryWrapper).fadeIn(500, function () {

            initTertiaryCategoryEvents();

        });

    }, 100);
}


async function initTertiaryCategoryEvents() {

    $(props.categoriesTertiarySelect).off("change").on('change', async function (e) {


        //first, pass selected id back to service that returns whether a sub-cat ddl shoudl be built or products returned.
        if ($(this).prop('selectedIndex') === 0) {

            slideUpProductResults();

            //reset to only showing breadcrumbs up to this category. 
            breadcrumbBuildCategoryLevelThreeSelected(null, null, true);

        }
        else {

            //NOTE: at the 3rd level the selected category can ONLY return products
            const categoryId = $(this).val();
            const categoryText = $(props.categoriesTertiarySelect + ' option:selected').text();

            //call service to load products using category id
            await getProductByCategory(categoryId);


            breadcrumbBuildCategoryLevelThreeSelected(categoryId, categoryText, false);
        }
    });
}

async function getProductByCategory(categoryId) {

    showWorkingIndicator(true);

    $(props.resultsWrapper).hide();

    const data = { categoryId: categoryId };

    const result = await getProductCategoryResultsService(data);

    await injectHtml(props.resultsWrapper, result);

    setTimeout(function () {

        showWorkingIndicator(false);

        $(props.resultsWrapper).slideDown(500, function () {

            initProductSelectionEvents();
        });

    }, 500);
}



//SEARCH FUNCTIONS
async function runManualFinderSearch() {

    //hide / reset secondary / tertiary ddl's

    showWorkingIndicator(true);

    $(props.resultsWrapper).hide();

    $(props.categoriesPrimarySelect).prop('selectedIndex', 0);
    $(props.categoriesPrimarySelect).change();

    const searchTerm = $(props.searchField).val();

    const data = { searchTerm: searchTerm };


    const result = await getProductSearchResultsService(data);

    await injectHtml(props.resultsWrapper, result);

    setTimeout(function () {

        showWorkingIndicator(false);

        $(props.resultsWrapper).slideDown(500, function () {

            initProductSelectionEvents();
        });

        breadcrumbBuildSearchRun(searchTerm);

    }, 500);
}

async function initProductSelectionEvents() {

    $(props.resultProductCta).off("click").on('click', async function (e) {

        var productId = $(this).data('id');
        var productName = $(this).data('item-title');

        searchProductVariantsWorker(productId, productName);

    });
}

async function searchProductVariantsWorker(productId, productName) {

    showWorkingIndicator(true);

    $(props.resultsWrapper).hide();

    const data = { id: productId };

    const result = await getProductVariantsService(data);

    await injectHtml(props.resultsWrapper, result);

    setTimeout(function () {

        showWorkingIndicator(false);

        $(props.resultsWrapper).slideDown(500, function () {

            initProductVariantSelectionEvents();
        });

        breadcrumbBuildProductSelected(productId, productName);

    }, 100);


}

async function initProductVariantSelectionEvents() {

    $(props.resultProductVariantCta).off("click").on('click', async function (e) {

        var productVariantId = $(this).data('id');
        var productName = $(this).data('item-title');

        searchProductVariantManualsWorker(productVariantId, productName);

    });
}

async function searchProductVariantManualsWorker(productVariantId, productName) {

    showWorkingIndicator(true);

    $(props.resultsWrapper).hide();

    const data = { id: productVariantId };

    const result = await getProductVariantManualsService(data);

    await injectHtml(props.resultsWrapper, result);

    setTimeout(function () {

        showWorkingIndicator(false);

        $(props.resultsWrapper).slideDown(500, function () {

            initProductVariantManualSelectedEvents();
        });

        breadcrumbBuildProductVariantSelected(productVariantId, productName);

    }, 100);

}

async function initProductVariantManualSelectedEvents() {

    //initilaise the change event for the language selected filter
    $(props.resultProductVariantManualSelectedLanguage).off("change").on('change', function (e) {

        var languageSelectedCode = $(this).val();

        $('.mf-product-variant-manual').css({ "display": "none" });

        $("div.mf-product-variant-manual[data-lang-code='" + languageSelectedCode + "']").css({ "display": "grid" });
    });

    $(props.resultProductVariantManualSelectedLanguage).change();
}


//BREADCRUMB MANAGEMENT

function breadcrumbBuildSearchRun(searchValue) {

    //called when the search is run on the view

    //hide all 'subsequent' possible segments
    hideElement($(props.breadcrumbWrapperCategoryLevelOne));
    hideElement($(props.breadcrumbWrapperCategoryLevelTwo));
    hideElement($(props.breadcrumbWrapperCategoryLevelThree));

    hideElement($(props.breadcrumbWrapperProductSelected));
    hideElement($(props.breadcrumbWrapperProductVariantSelected));

    //set display and data value for search term
    $(props.breadcrumbSegmentSearchterm).html(searchValue);
    $(props.breadcrumbSegmentSearchterm).data('search-value', searchValue);

    //display this segment
    showElement($(props.breadcrumbWrapperSearchterm));
}

function breadcrumbBuildCategoryLevelOneSelected(id, displayName, resetOnly) {


    //hide all 'subsequent' possible segments
    hideElement($(props.breadcrumbWrapperSearchterm));


    hideElement($(props.breadcrumbWrapperCategoryLevelTwo));
    hideElement($(props.breadcrumbWrapperCategoryLevelThree));

    hideElement($(props.breadcrumbWrapperProductSelected));
    hideElement($(props.breadcrumbWrapperProductVariantSelected));

    if (!resetOnly) {

        //if reset only is set to false then the command is to hide the 'upchain' segments, not to set the values for this element

        //set display and data value for this segment
        $(props.breadcrumbSegmentCategoryLevelOne).html(displayName);
        $(props.breadcrumbSegmentCategoryLevelOne).data('id', id);
        $(props.breadcrumbSegmentCategoryLevelOne).data('item-title', displayName);

        //display this segment
        showElement($(props.breadcrumbWrapperCategoryLevelOne));
    }
    else {

        //hide this segment
        hideElement($(props.breadcrumbWrapperCategoryLevelOne));
    }

}

function breadcrumbBuildCategoryLevelTwoSelected(id, displayName, resetOnly) {


    //hide all 'subsequent' possible segments
    hideElement($(props.breadcrumbWrapperCategoryLevelThree));

    hideElement($(props.breadcrumbWrapperProductSelected));
    hideElement($(props.breadcrumbWrapperProductVariantSelected));

    if (!resetOnly) {

        //if reset only is set to false then the command is to hide the 'upchain' segments, not to set the values for this element

        //set display and data value for this segment
        $(props.breadcrumbSegmentCategoryLevelTwo).html(displayName);
        $(props.breadcrumbSegmentCategoryLevelTwo).data('id', id);
        $(props.breadcrumbSegmentCategoryLevelTwo).data('item-title', displayName);

        //display this segment
        showElement($(props.breadcrumbWrapperCategoryLevelTwo));
    }
    else {

        //hide this segment
        hideElement($(props.breadcrumbWrapperCategoryLevelTwo));
    }
}

function breadcrumbBuildCategoryLevelThreeSelected(id, displayName, resetOnly) {


    //hide all 'subsequent' possible segments
    hideElement($(props.breadcrumbWrapperProductSelected));
    hideElement($(props.breadcrumbWrapperProductVariantSelected));

    if (!resetOnly) {

        //if reset only is set to false then the command is to hide the 'upchain' segments, not to set the values for this element

        //set display and data value for this segment
        $(props.breadcrumbSegmentCategoryLevelThree).html(displayName);
        $(props.breadcrumbSegmentCategoryLevelThree).data('id', id);
        $(props.breadcrumbSegmentCategoryLevelThree).data('item-title', displayName);

        //display this segment
        showElement($(props.breadcrumbWrapperCategoryLevelThree));
    }
    else {

        //hide this segment
        hideElement($(props.breadcrumbWrapperCategoryLevelThree));
    }

}

function breadcrumbBuildProductSelected(id, displayName) {

    //hide all 'subsequent' possible segments
    hideElement($(props.breadcrumbWrapperProductVariantSelected));


    //set display and data value for this segment
    $(props.breadcrumbSegmentProductSelected).html(displayName);
    $(props.breadcrumbSegmentProductSelected).data('id', id);
    $(props.breadcrumbSegmentProductSelected).data('item-title', displayName);

    //display this segment
    showElement($(props.breadcrumbWrapperProductSelected));
}

function breadcrumbBuildProductVariantSelected(id, displayName) {


    //set display and data value for this segment
    $(props.breadcrumbSegmentProductVariantSelected).html(displayName);
    $(props.breadcrumbSegmentProductVariantSelected).data('id', id);
    $(props.breadcrumbSegmentProductVariantSelected).data('item-title', displayName);

    //display this segment
    showElement($(props.breadcrumbWrapperProductVariantSelected));
}

function initBreadcrumbEvents() {

    $(props.breadcrumbSegmentSearchterm).off('click').on('click', function () {

        var searchTerm = $(this).data('search-value');

        $(props.searchField).val(searchTerm);

        runManualFinderSearch();
    });


    $(props.breadcrumbSegmentCategoryLevelOne).off('click').on('click', function () {

        const categoryId = $(this).data('id');

        $(props.categoriesPrimarySelect).val(categoryId).change();

    });


    $(props.breadcrumbSegmentCategoryLevelTwo).off('click').on('click', function () {

        const categoryId = $(this).data('id');

        $(props.categoriesSecondarySelect).val(categoryId).change();

    });

    $(props.breadcrumbSegmentCategoryLevelThree).off('click').on('click', function () {

        const categoryId = $(this).data('id');

        $(props.categoriesTertiarySelect).val(categoryId).change();

    });

    $(props.breadcrumbSegmentProductSelected).off('click').on('click', function () {

        const productId = $(this).data('id');
        const productTitle = $(this).data('item-title');

        searchProductVariantsWorker(productId, productTitle);

    });

    $(props.breadcrumbSegmentProductVariantSelected).off('click').on('click', function () {

        const productId = $(this).data('id');
        const productTitle = $(this).data('item-title');

        searchProductVariantManualsWorker(productId, productTitle);
    });
}

//HELPERS

function clearCategoryWrapperElement(elementSelector) {

    $(elementSelector).hide(500, function () {

        $(elementSelector).empty();
    });
}

function slideUpProductResults() {

    $(props.resultsWrapper).slideUp(300);
}

function showWorkingIndicator(show) {

    if (show) {

        $(props.loadingAnimationWrapper).show();
    } else {

        $(props.loadingAnimationWrapper).hide();
    }
}

function showElement(element) {
    element.removeClass('display-none');
    element.addClass('display-inline-block');
}

function hideElement(element) {
    element.removeClass('display-inline-block');
    element.addClass('display-none');
}



//API CALLS
async function getProductSearchResultsService(data) {

    //no TRY CATCH as handled by parent
    //returns result as html
    const response = await http.get('/support/buildproductsearchresults', data);

    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}


async function getProductCategoryResultsService(data) {

    //no TRY CATCH as handled by parent
    //returns result as html
    const response = await http.get('/support/buildproductcategoryresults', data);

    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}


async function getProductVariantsService(data) {

    //no TRY CATCH as handled by parent
    //returns result as html
    const response = await http.get('/support/buildproductvariantresults', data);

    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}

async function getProductVariantManualsService(data) {

    //no TRY CATCH as handled by parent
    //returns result as html
    const response = await http.get('/support/buildproductvariantmanuals', data);

    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}


async function categorySelectedResponseService(data) {

    //no TRY CATCH as handled by parent
    //returns result as html
    const response = await http.get('/support/categoryselectionresult', data);

    return response.data;
}

async function getCategorySelectedContentService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.get('/support/buildmanualfindercategories', data);

    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}
